import { useState, useEffect } from "react";

import { db } from "../../../../util/firebase";
import { query, collection, getDocs, addDoc } from "firebase/firestore";

import { v4 as uuidv4 } from "uuid";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { Button, Input, Modal, ModalBody } from "reactstrap";
import { IoClose } from "react-icons/io5";
import Swal from "sweetalert2";

function AdminCreateBundlePage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [status, setStatus] = useState("");
  const [addedProducts, setAddedProducts] = useState([]);

  const createBundle = async () => {
    try {
      setIsLoading(true);

      await addDoc(collection(db, "bundles"), {
        uid: uuidv4(),
        name: name,
        price: parseFloat(price),
        products: addedProducts,
        status: status,
        category: "BUNDLE",
      });

      navigate(-1);

      setIsLoading(false);
    } catch (err) {
      alert(err.message);
      setIsLoading(false);
    }
  };

  const [products, setProducts] = useState([]);
  const fetchProducts = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "products"));
      const querySnapshot = await getDocs(q);
      let fetchedProducts = [];
      querySnapshot.forEach((doc) => {
        fetchedProducts.push(doc.data());
      });
      setProducts(fetchedProducts);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching products");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line
  }, []);

  const [productSearchTerms, setProductSearchTerms] = useState("");

  const [addProductModal, setAddProductModal] = useState(false);
  const toggleAddProductModal = () => setAddProductModal(!addProductModal);

  const addProduct = (product) => {
    if (
      addedProducts.find((addedProduct) => addedProduct.uid === product.uid)
    ) {
      Swal.fire({
        text: "Product already added",
        icon: "error",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });

      return;
    }
    let newAddedProducts = addedProducts;
    newAddedProducts.push(product);
    setAddedProducts(newAddedProducts);

    toggleAddProductModal();
  };

  const removeProduct = (product) => {
    let newAddedProducts = addedProducts.filter(
      (addedProduct) => addedProduct.uid !== product.uid
    );
    setAddedProducts(newAddedProducts);

    Swal.fire({
      text: "Product removed",
      icon: "success",
      confirmButtonColor: "#005EE1",
      confirmButtonText: "OKAY",
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        CREATE BUNDLE
      </h1>
      <div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="The bundle's name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Price
        </p>
        <input
          type="number"
          className="mainInput"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          placeholder="The bundle's price"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Status
        </p>
        <Input
          type="select"
          className="mainInput"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The bundle's status
          </option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Products
        </p>
        <Button
          onClick={toggleAddProductModal}
          className="primaryBtn"
          style={{ marginBottom: "0.5rem" }}
        >
          ADD PRODUCT
        </Button>
        <Modal
          id="addProductModal"
          isOpen={addProductModal}
          toggle={toggleAddProductModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader">
              <div></div>
              <IoClose onClick={toggleAddProductModal} />
            </div>
            <div>
              <h1>ADD PRODUCT</h1>
              <div style={{ marginTop: "1rem" }}>
                <input
                  type="text"
                  className="mainInput"
                  value={productSearchTerms}
                  onChange={(e) => setProductSearchTerms(e.target.value)}
                  placeholder="Search..."
                  style={{ marginBottom: "1rem" }}
                />
                {productSearchTerms
                  ? products
                      .filter(
                        (product) =>
                          product.name
                            .toLowerCase()
                            .includes(productSearchTerms.toLowerCase()) ||
                          product.category
                            .toLowerCase()
                            .includes(productSearchTerms.toLowerCase())
                      )
                      .map((product, index) => (
                        <div
                          onClick={() => addProduct(product)}
                          key={index}
                          className="bundleProductCard"
                          style={{ cursor: "pointer" }}
                        >
                          <p>
                            <span className="bundleProductCategory">
                              {product.category}
                            </span>
                            &nbsp;
                            <span className="bundleProductName">
                              {product.name}
                            </span>
                          </p>
                          <p className="bundleProductPrice">${product.price}</p>
                        </div>
                      ))
                  : products.map((product, index) => (
                      <div
                        onClick={() => addProduct(product)}
                        key={index}
                        className="bundleProductCard"
                        style={{ cursor: "pointer" }}
                      >
                        <p>
                          <span className="bundleProductCategory">
                            {product.category}
                          </span>
                          &nbsp;
                          <span className="bundleProductName">
                            {product.name}
                          </span>
                        </p>
                        <p className="bundleProductPrice">${product.price}</p>
                      </div>
                    ))}
              </div>
            </div>
          </ModalBody>
        </Modal>
        <div className="addedProducts">
          {addedProducts?.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "0.5rem",
                marginBottom: "0.5rem",
              }}
            >
              No products added
            </p>
          ) : (
            addedProducts?.map((product, index) => (
              <div
                onClick={() => removeProduct(product)}
                key={index}
                className="addedProductCard"
              >
                <p>
                  <span className="bundleProductCategory">
                    {product.category}
                  </span>
                  &nbsp;
                  <span className="bundleProductName">{product.name}</span>
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <p className="bundleProductPrice">${product.price}</p>
                  <IoClose />
                </div>
              </div>
            ))
          )}
        </div>
        <Button
          onClick={createBundle}
          className="primaryBtn"
          style={{ marginTop: "1rem" }}
        >
          CREATE BUNDLE
        </Button>
      </div>
    </div>
  );
}

export default AdminCreateBundlePage;
